import { observer } from 'mobx-react';
import { FC, useMemo } from 'react';

import authStore from '../../../store/AuthStore';
import permissionStore from '../../../store/PermissionStore';
import Forbidden from '../Forbidden/Forbidden';
import { PermissionsWrapperProps } from './PermissionsWrapper.types';

const PermissionsWrapper: FC<PermissionsWrapperProps> = ({
  permissions,
  children,
}) => {
  const hasPermission = useMemo(
    () => permissions.some(p => permissionStore.hasPermission(p)),
    [authStore.authenticatedUser],
  );

  if (!authStore.authenticatedUser) {
    return <></>;
  }

  return hasPermission ? children : <Forbidden />;
};

export default observer(PermissionsWrapper);
